module.exports={
  message: {
    "Account": '用户管理',
    "User List":"用戶列表",
    "Role list":"角色列表",
    "userName": "用户名称",
    "Status": "状态",
    "Search": "搜寻",
    "datagridresult": "条结果",
    "RoleName": "角色名称",
    "createdTime": "创建日期",
    "Add": "新增",
    "Delete": "刪除",
    "password": "密码",
    "Tel": "电话",
    "email": "电邮",
    "Role": "角色",
    "Active": "已启动",
    "Inactive": "尚未启动",
    "Save": "储存",
    "Cancel": "取消",
    "Confirm": "确认",
    "Warning": "警告",
    "RoleType": "角色类型",
    "Super Admin": "超級管理員",
    "Platform": "平台管理員",
    "FunctionSelection": "功能",
    "All": "--- 全部 ---",
    "selectDefault": "--- 默认 ---",
    "PleaseSelect": "--- 请选择 ---",
    "title": "标题",
    "LogOut": "登出",
    "name":"name",
    "English":"英文",
    "Simplified Chinese":"简体",
    "Traditional Chinese":"繁体",
    "en_US":"英文",
    "zh_CN":"简体",
    "zh_HK":"繁体",
    "HomePage":"主页",
    "userDetail":"用户资料",
    "roleDetail":"角色资料",
    "Publish":"发布",
    "Draft":"草稿",
    "Published":"已发布",
    "Preview":"预览",
    "Edit":"编辑",
    "Tags":"标签",
    "Add tag":"增加标签",
    "Image size error":"图片档案大小错误！",
    "Dimension Error":"图片尺寸错误！",
    "deleteContent":"您确定要删除所选内容吗？",
    "Home":"主页",
    "Event":"Event",
    "Highlights":"Highlights",
    "Event Group List":"Event Group List",
    "Event List":"Event List",
    "Tag":"Tag",
    "Tag List":"Tag List",
    "Event Group Detail":"Event Group Detail",
    "Tag Detail":"Tag Detail",
    "synonyms":"synonyms",
    "id":"ID",
    "Group Title - Eng":"Group Title - Eng",
    "Start Date":"Start Date",
    "End Date":"End Date",
    "Rearrange Order":"Rearrange Order",
    "Group Title":"Group Title",
    "eventId":"eventId",
    "Group Types":"Group Types",
    "Event Types":"Event Types",
    "venue":"venue",
    "highlights":"highlights",
    "Group TitleTChi":"Group Title - T.Chi",
    "Group TitleSChi":"Group Title - S.Chi",
    "Series":"Series",
    "Package":"Package",
    "Festival":"Festival",
    "Unpublish":"Unpublish",
    "Xiqu Centre":"Xiqu Centre",
    "Freespace":"Freespace",
    "Art Park":"Art Park",
    "Multi-venue":"Multi-venue",
    "Out-of-district":"Out-of-district",
    "M+ Pavillian":"M+ Pavillian",
    "order":"order",
    "Title - Eng":"Title - Eng",
    "TitleTChi":"Title - T.Chi",
    "TitleSChi":"Title - S.Chi",
    "Event Detail":"Event Detail",
    "required":"这是必填项",
    "preview":"preview",
    "Event Search":"Event Search",
    "Hot Tags":"Hot Tags",
    "Hot Events":"Hot Events",
    "Key Visual":"Key Visual",
    "Key Visual & Greeting Message List":"Key Visual & Greeting Message List",
    "keyword":"Keyword",
    "Key Visual Detail":"Key Visual Detail",
    "Landing Page Management":"Landing Page Management",
    "editorial List":"editorial List",
    "editorial Detail":"editorial Detail",
    "Editorial Management":"Editorial Management",
    "Daily Recommendation":"Daily Recommendation",
    "Editorial List":"Editorial List",
    "Visit Management":"Visit Management",
    "Shop Description":"Shop Description",
    "Dining Description":"Dining Description",
    "Amenities Description":"Amenities Description",
    "Transportation Description":"Transportation Description",
    "Social Media List":"Social Media List",
    "Social Media Detail":"Social Media Detail",
    "Accessibility Statement":"Accessibility Statement",
    "Accessibility App Usages":"Accessibility App Usages",
    "FAQ":"FAQ",
    "About us":"About us",
    'Terms & Conditions':"Terms & Conditions",
    "More Management":"More Management",
    "Hot Editorials":"Hot Editorials",
    "fillRequired":"Please fill in the required information",
    "Tips/Reminders":"Tips/Reminders",
    "Special Announcement":"Special Announcement",
    "Special Announcement Detail":"Special Announcement Detail",
    "Arwiz":"Arwiz",
  }
}